import type { ReactNode } from "react";
import { Tooltip } from "@mantine/core";
import Info from "lucide-react/dist/esm/icons/info";

/** A dimmed info icon that explains something on hover, focus or tap. */
export function InfoHint({ label, size = 14 }: { label: ReactNode; size?: number }) {
  return (
    <Tooltip label={label} multiline maw={300} withArrow events={{ hover: true, focus: true, touch: true }}>
      <Info size={size} tabIndex={0} style={{ color: "var(--mantine-color-dimmed)", flexShrink: 0, cursor: "help" }} />
    </Tooltip>
  );
}

/** A label or column header with an info icon after it, instead of a description line under the field. */
export function WithHint({ children, hint, gap = 4 }: { children: ReactNode; hint: ReactNode; gap?: number }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap }}>
      {children}
      <InfoHint label={hint} />
    </span>
  );
}
